import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/FunnelSimple.es.js";
const o = e.forwardRef((n, m) => /* @__PURE__ */ e.createElement(r, { ref: m, ...n, weights: t }));
o.displayName = "FunnelSimpleIcon";
const l = o;
export {
  l as FunnelSimple,
  o as FunnelSimpleIcon
};
